import React, { FC, useEffect, useState } from 'react';

import '../css/normalize.css';
import '../css/webflow.css';
import '../css/salarysimwebflow.css';
import '../css/salarysimwebflow_custom.css';
import '../css/salarysim.css';

import { UseSalarySimContext } from '../Context/SalarySimContext';
import { UseTranslationContext } from '../Context/TranslationContext';

const SimulationMode: FC = () => {

  const{isSimpleSimulationMode, ToggleSimulationMode } = UseSalarySimContext();
  const { getKeyFromKeyId } = UseTranslationContext();

  const [selectedMode, setSelectedMode] = useState('simple');

  const handleSimulationButtonChange = (wantedSimulationMode: boolean) => {
        if(ToggleSimulationMode != null){ToggleSimulationMode(wantedSimulationMode)};
     };

     const handleSimulationSelectChange = (event: any) => {
       if(event.target.value == "simple")
        {
          if(ToggleSimulationMode != null){ToggleSimulationMode(true)};
        }
        else
        {
          if(ToggleSimulationMode != null){ToggleSimulationMode(false)};
        }
    };

    useEffect(()=>{
      setSelectedMode(isSimpleSimulationMode?'simple':'advanced');
    },[isSimpleSimulationMode]);

return (
    <>
      <nav id="toggle-nav" role="listbox" aria-label="options de calcul" tabIndex={-1} className="toggle-nav">
        { /* FOR MOBILE DISPLAY */ }
        <div className="select-calcul">
          <select id="options-calcul" value={selectedMode} name="options-calcul" data-name="options-calcul" className="list-calcul w-select" onChange={(e) => handleSimulationSelectChange(e)}>
              <option value="simple">{getKeyFromKeyId("SIMPLE")}</option>
              <option value="advanced">{getKeyFromKeyId("ADVANCED")}</option>
            </select>
        </div>

        { /* FOR FULLSCREEN DISPLAY */ }
        <button id="button-toggle-left" role="option" onClick={() => handleSimulationButtonChange(true)} className={(isSimpleSimulationMode == true)?"button-toggle-left w-inline-block":"button-toggle-left inactf w-inline-block w--current"}>
          <div className={(isSimpleSimulationMode == true)?"text-button":"text-button-grey"}>{getKeyFromKeyId("SIMPLE")}</div>
        </button>
        <button id="button-toggle-right" role="option"  onClick={() => handleSimulationButtonChange(false)} className={(isSimpleSimulationMode == false)?"button-toggle-right w-inline-block":"button-toggle-right inactf w-inline-block w--current"}>
          <div className={(isSimpleSimulationMode == false)?"text-button":"text-button-grey"}>{getKeyFromKeyId("ADVANCED")}</div>
        </button>
      </nav>   
    </>
  )
}

export default SimulationMode;
  


